import currencyJs from 'currency.js'

const moneyInputPattern = /^-?\d+(?:[,.]\d{1,2})?$/

export const parseMoneyInput = (value: string): string | undefined => {
    const normalizedValue = value.replace(/[\s\u00a0]/g, '').replace(',', '.')

    if (!moneyInputPattern.test(normalizedValue)) return

    return currencyJs(normalizedValue, { precision: 2 }).toString()
}

export const formatMoneyInput = (value: string): string => {
    const amount = parseMoneyInput(value)

    if (!amount) return value

    const precision = Number.isInteger(Number(amount)) ? 0 : 2

    return currencyJs(amount, { precision }).format({
        decimal: ',',
        pattern: '#',
        separator: ' ',
        symbol: '',
    })
}

export const toEditableMoneyInput = (value: string): string => {
    const amount = parseMoneyInput(value)

    if (!amount) return value

    return Number.isInteger(Number(amount))
        ? currencyJs(amount, { precision: 0 }).toString()
        : amount.replace('.', ',')
}
